import HeartIcon from 'components/assets/tick-heart.svg';
import Currency from 'components/atoms/Currency/Currency';
import ReferralCard from 'components/molecules/ReferralCard/ReferralCard';
import { LifetimeReferralsStats_referralsRef_qmee$key } from 'components/organisms/LifetimeReferralsStats/__generated__/LifetimeReferralsStats_referralsRef_qmee.graphql';
import { useRouter } from 'next/router';
import { graphql, useFragment } from 'react-relay';
import { getCurrencyFromLocale } from 'utils/locale';
import classes from './LifetimeReferralsStats.module.scss';

export type Props = {
  referralsRef: LifetimeReferralsStats_referralsRef_qmee$key;
  walletCurrency?: string | null;
};

export default function LifetimeReferralsStats({ referralsRef, walletCurrency }: Readonly<Props>) {
  const { locale } = useRouter();
  const data = useFragment<LifetimeReferralsStats_referralsRef_qmee$key>(
    graphql`
      fragment LifetimeReferralsStats_referralsRef_qmee on ReferralHistory {
        lifetime {
          successes
          earnings {
            subUnitAmount
            currency
          }
        }
      }
    `,
    referralsRef,
  );

  const earningsSubUnit = data.lifetime.earnings?.subUnitAmount ?? 0;
  // When the user has no earnings yet the backend returns the account default (USD),
  // which is wrong for non-US users. Prefer the wallet currency in that case.
  const displayCurrency =
    earningsSubUnit > 0 && data.lifetime.earnings?.currency
      ? data.lifetime.earnings.currency
      : (walletCurrency ?? getCurrencyFromLocale(locale));

  return (
    <div className={classes.root}>
      <ReferralCard
        title="Lifetime Paid Referrals"
        value={data.lifetime.successes}
        icon={<HeartIcon className={classes.icon} />}
      />
      <ReferralCard
        title="Lifetime Earnings"
        value={
          <Currency
            amount={earningsSubUnit / 100}
            currency={displayCurrency}
            options={{
              maximumFractionDigits: 2,
              minimumFractionDigits: 0,
            }}
          />
        }
      />
    </div>
  );
}
